import React from 'react';
import { AD_ATTRIBUTES } from '../utils/adAttributes';
import './ShortcodeGlossary.css';

function ShortcodeGlossary({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal glossary-modal" onClick={(e) => e.stopPropagation()}>
        <div className="glossary-header">
          <h2>📚 Glossaire des champs Active Directory</h2>
          <button className="glossary-close" onClick={onClose}>×</button>
        </div>

        <div className="glossary-intro">
          <p>
            Utilisez ces shortcodes dans vos champs texte pour insérer automatiquement
            les données depuis Active Directory. Les valeurs seront remplacées lors de
            la génération des signatures.
          </p>
        </div>

        <div className="glossary-content">
          {AD_ATTRIBUTES.map((category, idx) => (
            <div key={idx} className="glossary-category">
              <h3 className="glossary-category-title">{category.category}</h3>
              <div className="glossary-table">
                <table>
                  <thead>
                    <tr>
                      <th>Champ</th>
                      <th>Shortcode</th>
                      <th>Attribut AD</th>
                      <th>Exemple</th>
                    </tr>
                  </thead>
                  <tbody>
                    {category.attributes.map((attr, attrIdx) => (
                      <tr key={attrIdx}>
                        <td className="glossary-label">{attr.label}</td>
                        <td>
                          <code className="glossary-code">{attr.shortcode}</code>
                        </td>
                        <td className="glossary-ad-attr">{attr.adAttribute}</td>
                        <td className="glossary-example">{attr.example}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>

        <div className="glossary-footer">
          <div className="glossary-tips">
            <h4>💡 Conseils d'utilisation</h4>
            <ul>
              <li>Cliquez sur le bouton <strong>{'{ } Champ AD'}</strong> à côté des champs texte pour insérer rapidement un shortcode</li>
              <li>Les shortcodes sont sensibles à la casse et doivent être entourés d'accolades</li>
              <li>Vous pouvez combiner du texte libre avec des shortcodes : "Bonjour {'{firstname}'}, contactez-moi au {'{phone}'}"</li>
              <li>Si un champ AD est vide, le shortcode sera remplacé par une chaîne vide</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShortcodeGlossary;
